import { NgModule } from "@angular/core";
import { UIRouterModule, Ng2StateDeclaration } from "@uirouter/angular";
import { ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AllMaterialModule } from "../all-material.components";
import { CommonModule } from '@angular/common';
import { ChangePassword } from "./change-password.component";
import { ForgotPassword } from "./forgot-password.component";
import {
    passwordState,
    changePasswordState,
    forgotPasswordState,
    resetPasswordState
} from "./password.states";
import { ResetPassword } from "./reset-password.component";
import { PasswordOperations } from "./password-operations.component";

const STATES: Ng2StateDeclaration[] = [
    passwordState,
    changePasswordState,
    forgotPasswordState,
    resetPasswordState
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AllMaterialModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: STATES })
    ],
    declarations: [
        ChangePassword,
        ForgotPassword,
        ResetPassword,
        PasswordOperations]
})
export class PasswordModule {
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/password/password.module.ts